import Api from "@/services/Index";

const create = async (data, job) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    let response = {}
    if(job != 1){
        response.responseType = 'arraybuffer'
    }

    return Api.post('/student/programs/contact-information-excel-export', data, response );
}
export default {
   create
}
